import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/student-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/student-profiles', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/student-profiles/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/student-profiles/${data.student_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const updateStatus = data => {
  return httpClient
    .post('/api/student-profiles/update-status', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const checkStatusBySubProgram = data => {
  return httpClient
    .post('/api/student-profiles/check-status-by-sub-programs', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const updateStatusBySubProgram = data => {
  return httpClient
    .post('/api/student-profiles/update-status-by-sub-programs', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const printCard = (Options = {}) => {
  return httpClient
    .get('/api/student-profiles/preview-cards', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const exportExcel = data => {
  return httpClient
    .post('/api/student-profiles/export-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = data => {
  return httpClient
    .post('/api/student-profiles/delete-records', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const nationality = (Options = {}) => {
  return httpClient
    .get('/api/student-profiles/nationalities')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const religion = (Options = {}) => {
  return httpClient
    .get('/api/student-profiles/religions')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const itemList = (Options = {}) => {
  return httpClient
    .get('/api/student-profiles/item-lists')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getStatus = (Options = {}) => {
  return httpClient
    .get('/api/student-profiles/status')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const province = (Options = {}) => {
  return httpClient
    .get('/api/student-profiles/provinces')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const district = (province_code, Options = {}) => {
  return httpClient
    .get(`/api/student-profiles/${province_code}/districts`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const commune = (district_code, Options = {}) => {
  return httpClient
    .get(`/api/student-profiles/${district_code}/communes`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const village = (commune_code, Options = {}) => {
  return httpClient
    .get(`/api/student-profiles/${commune_code}/villages`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const uploadPhoto = data => {
  return httpClient
    .post('/api/student-profiles/upload-photoes', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const uploadAudio = data => {
  return httpClient
    .post('/api/student-profiles/audios', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const increasePrinterCardCounter = studentId => {
  return httpClient
    .get(`/api/student-profiles/increase/${studentId}/print-card-counters`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const bankAccount = (id, Options = {}) => {
  return httpClient
    .get(`/api/student-profiles/${id}/bank-accounts`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const addParent = data => {
  return httpClient
    .post('/api/student-profiles/add-parents', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data));
};

export const checkChangeModeExternalTrueToFalse = data => {
  return httpClient
    .post('/api/student-profiles/check-privilege/change-mode-external-true-to-false', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const checkChangeModeExternalFalseToTrue = data => {
  return httpClient
    .post('/api/student-profiles/check-privilege/change-mode-external-false-to-true', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const formViewModel = (Options = {}) => {
  return httpClient
    .get(`/api/student-profiles/form-view-models`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  updateStatus,
  destroy,
  nationality,
  religion,
  itemList,
  getStatus,
  province,
  district,
  commune,
  village,
  uploadPhoto,
  uploadAudio,
  printCard,
  exportExcel,
  checkStatusBySubProgram,
  updateStatusBySubProgram,
  increasePrinterCardCounter,
  bankAccount,
  addParent,
  checkChangeModeExternalTrueToFalse,
  checkChangeModeExternalFalseToTrue,
  formViewModel
}
